"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var Tag_1 = __importDefault(require("./Tag"));
exports.Tag = Tag_1.default;
exports.default = Tag_1.default;
//# sourceMappingURL=index.js.map